/**
 * Logo Font Configuration — Single Source of Truth
 *
 * Every place that renders the "myvitae.ai" wordmark (React components,
 * marketing templates, logo generator) imports from this file.
 * Change the values here and the font updates everywhere instantly.
 *
 * Used by:
 *   - React: Logo.js, NavBarLogo.js, Landing hero, AuthLayout, error pages, etc.
 *   - Marketing: centeredLogo.js, logoWatermark.js, brandStatement.js
 *   - Logo generator: logo/generate-logo.js
 *
 * Format: CommonJS so both webpack (React) and Node scripts can consume it.
 */

const LOGO_FONT_FAMILY = "'Quicksand', system-ui, sans-serif";
const LOGO_GOOGLE_FONT = 'Quicksand';
const LOGO_FONT_WEIGHT = 600;

const logoFontStyle = {
  fontFamily: LOGO_FONT_FAMILY,
  fontWeight: LOGO_FONT_WEIGHT,
};

module.exports = {
  LOGO_FONT_FAMILY,
  LOGO_GOOGLE_FONT,
  LOGO_FONT_WEIGHT,
  logoFontStyle,
};
